/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".superadmin[_ngcontent-%COMP%] {\n  height: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9naXRodWIvd29ya3NwYWNlL3NyYy9hcHAvc3VwZXJhZG1pbi9zdXBlcmFkbWluLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9zdXBlcmFkbWluL3N1cGVyYWRtaW4uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0FDQ0YiLCJmaWxlIjoic3JjL2FwcC9zdXBlcmFkbWluL3N1cGVyYWRtaW4uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc3VwZXJhZG1pbiB7XG4gIGhlaWdodDogMTAwJTtcbn1cbiIsIi5zdXBlcmFkbWluIHtcbiAgaGVpZ2h0OiAxMDAlO1xufSJdfQ== */"];
export { styles as styles };
